import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { message } from 'antd';

import getOrganizationByStatus from '../../graphql/SuperAdmin';
import { requestUserByEmail, getGovernmentUsers, allProcurementUser } from '../../graphql/users';
import history from '../../config/history';
import { requestOrganizationById, organizationByCage } from './graphql';
// import history from '../../config/history';
import { superAdminHomeRoute } from '../../config/navigation/routes';
import { getFiaOrgs, getInvitations, getNffsOrgs } from '../Invitation/Invitation';

export default function SuperAdminHOC(SuperAdminMenu) {
  class WrappedComponent extends Component {
    static propTypes = {
      auth: PropTypes.shape({
        jwtToken: PropTypes.string.isRequired,
        expiration: PropTypes.number.isRequired,
        organizationId: PropTypes.string.isRequired,
        role: PropTypes.string.isRequired,
      }).isRequired,
      location: PropTypes.shape({
        pathname: PropTypes.string.isRequired,
      }).isRequired,
    };

    static initialState = {
      showToast: false,
      toastLevel: '',
      toastMessage: '',
      // govOrgId: 'test',
      requests: [],
      capabilities: [],
      showCapModal: false,
      errors: [],
      isLoading: true,
      selectedMenu: { text: 'View Pending Request', value: 'pendingReqs' },
      cage: null,
      email: null,
      name: null,
      phone: null,
      orgName: null,
      users: [],
      loading: false,
      organizationsCage: undefined,
      organizationStatus: undefined,
      organizationsName: undefined,
      userType: {
        isAllUsers: true,
        isGovernmentUser: false
      },
      govUsers: [],
      industryUsersList: []
    };

    state = WrappedComponent.initialState;
    async fetchAllProcUsers() {
      try {
        const response = await allProcurementUser();
        this.setState({
          isLoading: false,
          users: response.allProcurementUser.govProcUserData,
        });
      } catch (error) {
        message.error('Failed to load Proc users');
        this.setState({ isLoading: false });
      }
    }
    // This code causes loading signal to disappear before table is finished loading
    // async componentDidUpdate(prevProps) {
    //   if (this.props.location.pathname !== prevProps.location.pathname) {
    //     await this.fetchAllProcUsers();
    //   }

    // }
    static getDerivedStateFromProps(nextProps, prevState) {
      if (prevState.email === '' && prevState.userType.isGovernmentUser) {
        return {
          users: prevState.govUsers
        };
      }
      if (prevState.email === '' && !prevState.userType.isGovernmentUser) {
        return {
          users: prevState.industryUsersList
        }
      }
      if (prevState.cage === '' && prevState.userType.isGovernmentUser) {
        return {
          users: prevState.govUsers
        };
      }
      if (prevState.cage === '' && !prevState.userType.isGovernmentUser) {
        return {
          users: prevState.industryUsersList
        };
      }
      return null;
    }
    async componentDidMount() {
      if (!this.users) {
        await this.fetchAllProcUsers();
      }
      // const res = await organizationByCage('O0000');
      // const govOrgId = res.organizationInDB.id;
      // this.setState({
      //   govOrgId,
      // });
      const {
        location: { pathname } = {},
      } = this.props;
      const pageMatch = pathname ? pathname.match(/([^/]*)\/*$/) : null;
      // const page = pathname.match(/([^\/]*)\/*$/)[1];
      const page = pageMatch ? pageMatch[1] : '';
      let response;
      if (page === ':page' || page === 'home') {
        const url = superAdminHomeRoute.replace(':page', 'pendingReqs');
        history.replace(url);
        response = await getOrganizationByStatus('requested');
        if (response && response.organizationByStatus) {
          requests = response.organizationByStatus.organizations || [];
        } else {
          requests = [];
        }
        this.setState({
          requests,
          isLoading: false,
        });
      } else {
        // the list of filters for the tab name for refresh and hot linking if you add a new page you need to add it to this filter list
        const filters = {
          searchUsers: { text: 'Search Users', value: 'searchUsers' },
          addOrganization: {
            text: 'Add New Organization',
            value: 'addOrganization',
          },
          viewEntities: { text: 'View Organizations', value: 'viewEntities' },
          pendingReqs: { text: 'View Pending Request', value: 'pendingReqs' },
          rejectedReqs: {
            text: 'View Rejected Request',
            value: 'rejectedReqs',
          },
          viewInvited: { text: 'View Invited Orgs', value: 'viewInvited' },
          viewNffs: { text: 'View NFFS Orgs', value: 'viewNffs' },
          viewFia: { text: 'View FIA Orgs', value: 'viewFia' },
          banner: {
            text: 'Edit Banner',
            value: 'banner',
          },
        };

        this.setState({ selectedMenu: filters[page] });
        this.setState({
          requests: [],
          isLoading: true,
        });

        switch (page) {
          case 'pendingReqs':
            response = await getOrganizationByStatus('requested');
            if (response && response.organizationByStatus) {
              requests = response.organizationByStatus.organizations || [];
            } else {
              requests = [];
            }
            this.setState({
              requests,
              isLoading: false,
            });
            break;

          case 'viewEntities':
            response = await getOrganizationByStatus('approved');
            if (response && response.organizationByStatus) {
              requests = response.organizationByStatus.organizations || [];
            } else {
              requests = [];
            }
            this.setState({
              requests,
              isLoading: false,
            });
            break;
          case 'rejectedReqs':
            response = await getOrganizationByStatus('denied');
            if (response && response.organizationByStatus) {
              requests = response.organizationByStatus.organizations || [];
            } else {
              requests = [];
            }
            this.setState({
              requests,
              isLoading: false,
            });
            break;
          case 'viewInvited':
            response = await getInvitations();
            if (response && response.organizationByStatus) {
              requests = response.organizationByStatus.organizations || [];
            } else {
              requests = [];
            }
            this.setState({
              requests,
              isLoading: false,
            });
            break;
          case 'viewNffs':
            console.log('viewNffs');
            response = await getNffsOrgs();
            if (response && response.organizationByStatus) {
              requests = response.organizationByStatus.organizations || [];
              capabilities = response.organizationByStatus.capabilities;
            } else {
              requests = [];
              capabilities = [];
            }
            this.setState({
              requests,
              capabilities,
              isLoading: false,
            });
            break;
          case 'viewFia':
            console.log('viewFia');
            response = await getFiaOrgs();
            if (response && response.organizationByStatus) {
              requests = response.organizationByStatus.organizations || [];
              capabilities = response.organizationByStatus.capabilities || [];
            } else {
              requests = [];
              capabilities = [];
            }
            this.setState({
              requests,
              capabilities,
              isLoading: false,
            });
            break;
          default:
            this.setState({
              isLoading: false,
            });
            break;
        }
      }
      let requests;
      let capabilities;
      if (response) {
        if (response.organizationByStatus) {
          requests = response.organizationByStatus.organizations || [];
          capabilities = response.organizationByStatus.capabilities || [];
        } else {
          requests = [];
          capabilities = [];
        }

        this.setState({
          requests,
          capabilities,
          isLoading: false,
        });
      }
    }

    // componentWillReceiveProps(nextProps) {
    //   const pathname = nextProps.location.pathname;
    //   const page = pathname.match(/([^\/]*)\/*$/)[1];
    //   if (page === ':page' || page === 'home') {
    //     const url = superAdminHomeRoute.replace(':page', 'pendingReqs');
    //     history.replace(url);
    //   }
    // }

    _onNewUserClick = () => {
      const { users } = this.state;
      const newUser = {
        fullName: '',
      };
      const updatedUsers = [...users, newUser];
      this.setState({ users: updatedUsers, viewNewUserForm: true });
    };

    _onSubmit = async (cage, email, currentUserType, name, phone, orgName) => {
      this.setState({
        // users: response.organization.users,
        isLoading: true,
      });

      if (email === '' && cage === '' && name === '' && phone === '' && orgName === '') {
        if (currentUserType) {
          this.setState({
            users: this.state.govUsers
          });
        } else {
          this.setState({
            users: this.industryUsersList
          });
        }
        this.setState({ isLoading: false });
        return;
      }

      let searchResults = [];
      const searchInUsers = (users) => {
        if (!Array.isArray(users)) return [];
        return users.filter(user => {
          if (!user) return false;
          const matchesEmail = email ? (user.email || '').toLowerCase().includes(email.toLowerCase()) : true;
          const matchesName = name ? (user.name || '').toLowerCase().includes(name.toLowerCase()) : true;

          // Normalize phone numbers by removing all non-digit characters
          const normalizePhone = (phoneStr) => (phoneStr || '').replace(/\D/g, '');
          const userPhone = normalizePhone(user.phoneNumber || user.phone || '');
          const searchPhone = normalizePhone(phone);
          const matchesPhone = phone ? userPhone.includes(searchPhone) : true;

          const matchesOrg = orgName ? (user.orgName || '').toLowerCase().includes(orgName.toLowerCase()) : true;
          const matchesCage = cage ? (user.cageCode || '').toLowerCase().includes(cage.toLowerCase()) : true;
          return matchesEmail && matchesName && matchesPhone && matchesOrg && matchesCage;
        });
      };

      if (currentUserType) {
        searchResults = searchInUsers(this.state.govUsers || []);
      } else {
        searchResults = searchInUsers(this.state.industryUsersList || []);
      }

      if (searchResults.length > 0) {
        const firstUser = searchResults[0];
        if (firstUser && firstUser.organizationId) {
          const org = await requestOrganizationById(firstUser.organizationId);
          if (org && org.organization) {
            this.setState({
              isLoading: false,
              users: searchResults,
              organizationsCage: org.organization.cageCode,
              organizationsName: org.organization.name,
              organizationsStatus: org.organization.iconStatus,
            });
            return;
          }
        }
      }

      this.setState({
        isLoading: false,
        users: [],
        organizationsCage: undefined,
        organizationsName: undefined,
        organizationsStatus: undefined,
      });
      message.error('No Users Found');
    };

    fetchAllProcUsers = async () => {
      try {
        this.setState({
          isLoading: true,
          userType: {
            isGovernmentUser: false,
            isAllUsers: true
          }
        });
        const response = await allProcurementUser();
        const filterResponse = response.allProcurementUser.govProcUserData.filter(el => (el.name !== '')).filter((el) => el.role !== 'government_user')
        this.setState({
          isLoading: false,
          users: filterResponse,
          industryUsersList: filterResponse
        });
      } catch (error) {
        this.setState({ isLoading: false });
      }
    }
    _onGetGovernmentUsers = async () => {

      this.setState({
        email: undefined,
        cage: undefined,
        isLoading: true,
      });

      const response = await getGovernmentUsers();

      this.setState({
        users: response.governmentUsers.govProcUserData,
        organizationsCage: undefined,
        organizationsName: undefined,
        organizationsStatus: undefined,
        govUsers: response.governmentUsers.govProcUserData
      });

      this.setState({
        isLoading: false,
      });

    };

    _onChange = e => {
      const value = e.target.value;
      const name = e.target.name;
      if (name === 'email') {
        this.setState({
          email: value,
          cage: undefined,
          name: undefined,
          phone: undefined,
          orgName: undefined
        });
      } else if (name === 'cage') {
        this.setState({
          cage: value,
          email: undefined,
          name: undefined,
          phone: undefined,
          orgName: undefined
        });
      } else if (name === 'name') {
        this.setState({
          name: value,
          email: undefined,
          cage: undefined,
          phone: undefined,
          orgName: undefined
        });
      } else if (name === 'phone') {
        this.setState({
          phone: value,
          email: undefined,
          cage: undefined,
          name: undefined,
          orgName: undefined
        });
      } else if (name === 'orgName') {
        this.setState({
          orgName: value,
          email: undefined,
          cage: undefined,
          name: undefined,
          phone: undefined
        });
      }
    };

    _refreshUsers = async () => {

      this.setState({
        // users: response.organization.users,
        isLoading: true,
      });
      // set timeout so changes have chance to get via dynamoDB to DB2 before reloading the users

      if (this.state.email) {
        const response = await requestUserByEmail(this.state.email);
        this.setState({
          users: [response.userByEmail],
          isLoading: false,
        });
      } else if (this.state.cage) {
        const response = await organizationByCage(
          this.state.cage.toUpperCase(),
        );
        this.setState({
          isLoading: false,
          users: response.organizationInDB.users,
        });
      } else {
        setTimeout(async () => {
          if (this.state.userType.isGovernmentUser) {

            const response = await getGovernmentUsers();
            this.setState({
              isLoading: false,
              users: response.governmentUsers.govProcUserData,
              govUsers: response.governmentUsers.govProcUserData
            });
          }
          if (this.state.userType.isAllUsers) {

            const response = await allProcurementUser();
            const filterResponse = response.allProcurementUser.govProcUserData.filter(el => (el.name !== '')).filter((el) => el.role !== 'government_user')
            this.setState({
              isLoading: false,
              users: filterResponse,
              industryUsersList: filterResponse
            });
          }
        }, 1500)
      }

    };

    _onHandleUserTypeSwitchChange = (switchType, checked) => {
      this.setState({
        userType: {
          isAllUsers: switchType === "allUsers" ? checked : !checked,
          isGovernmentUser: switchType === "governmentUsers" ? checked : !checked
        }
      },
        () => {
          if (this.state.userType.isAllUsers) {
            this.setState({
              isLoading: true,
            });
            this.fetchAllProcUsers()
          }

          if (this.state.userType.isGovernmentUser) {
            this._onGetGovernmentUsers()
          }
        }
      );
    };

    _onViewOrgSubmit = async (orgName, cageCode) => {
      this.setState({
        requests: [],
        isLoading: true,
      });

      const orgsArray = [];
      const response = await getOrganizationByStatus('approved');
      let requests = response.organizationByStatus.organizations || [];

      if (response.organizationByStatus && cageCode !== '') {
        let cage = '';
        for (let i = 0; i < requests.length; i += 1) {
          cage = requests[i].cageCode;
          if (cage) {
            cage = cage.toString().toUpperCase();
            if (cage.indexOf(cageCode.toUpperCase()) !== -1) {
              orgsArray.push(requests[i]);
            }
          }
        }
        requests = orgsArray;
        if (orgsArray.length === 0) {
          requests = [];
        }
      } else if (response.organizationByStatus && orgName !== '') {
        let name = '';
        for (let i = 0; i < requests.length; i += 1) {
          name = requests[i].name;
          if (name !== null) {
            name = name.toString().toLowerCase();
            if (name.indexOf(orgName.toLowerCase()) !== -1) {
              orgsArray.push(requests[i]);
            }
          }
        }
        requests = orgsArray;
        if (orgsArray.length === 0) {
          requests = [];
        }
      } else {
        requests = [];
      }
      this.setState({
        requests,
        isLoading: false,
      });

      //  const url = superAdminHomeRoute.replace(':page', 'viewEntities');
      // history.replace(url);
    };

    _onFilterClick = async filter => {
      this.setState({
        selectedMenu: filter,
        requests: [],
        isLoading: true,
      });
      this.refreshOrganizations(filter);
      const url = superAdminHomeRoute.replace(':page', filter.value);
      history.replace(url);
    };

    refreshOrganizations = async (filter = this.state.selectedMenu) => {
      let response;
      let requests;
      let capabilities;
      this.setState({
        requests: [],
        isLoading: true,
      });

      switch (filter.value) {
        case 'pendingReqs':
          response = await getOrganizationByStatus('requested');
          if (response && response.organizationByStatus) {
            requests = response.organizationByStatus.organizations || [];
          } else {
            requests = [];
          }
          this.setState({
            requests,
            isLoading: false,
          });
          break;

        case 'viewEntities':
          response = await getOrganizationByStatus('approved');
          if (response && response.organizationByStatus) {
            requests = response.organizationByStatus.organizations || [];
          } else {
            requests = [];
          }
          this.setState({
            requests,
            isLoading: false,
          });

          break;

        case 'rejectedReqs':
          response = await getOrganizationByStatus('denied');
          if (response && response.organizationByStatus) {
            requests = response.organizationByStatus.organizations || [];
          } else {
            requests = [];
          }
          this.setState({
            requests,
            isLoading: false,
          });
          break;
        case 'viewInvited':
          response = await getInvitations();
          if (response && response.organizationByStatus) {
            requests = response.organizationByStatus.organizations || [];
          } else {
            requests = [];
          }
          this.setState({
            requests,
            isLoading: false,
          });
          break;
        case 'viewNffs':
          response = await getNffsOrgs();
          if (response && response.organizationByStatus) {
            requests = response.organizationByStatus.organizations || [];
            capabilities = response.organizationByStatus.capabilities || [];
          } else {
            requests = [];
            capabilities = [];
          }
          this.setState({
            requests,
            capabilities,
            isLoading: false,
          });
          break;
        case 'viewFia':
          response = await getFiaOrgs();
          if (response && response.organizationByStatus) {
            requests = response.organizationByStatus.organizations || [];
            capabilities = response.organizationByStatus.capabilities || [];
          } else {
            requests = [];
            capabilities = [];
          }
          this.setState({
            requests,
            capabilities,
            isLoading: false,
          });
          break;
        default:
          this.setState({
            isLoading: false,
          });
          break;
      }
    }

    onUpdate = (item) => {
      const updatedRequests = this.state.requests.map((row) =>
        row.name === item.name ? { ...row, ...item } : row
      );
      this.setState({
        requests: updatedRequests
      });
    }

    openCapModal = () => {
      this.setState({
        showCapModal: true,
      })
    }

    closeCapModal = () => {
      this.setState({
        showCapModal: false,
      })
    }
    _onError = (toastLevel, toastMessage) => {
      this.setState(
        {
          toastLevel,
          toastMessage,
          showToast: true,
        },
        () => {
          setTimeout(() => this.setState({ showToast: false }), 3000);
        },
      );
    };

    render() {
      const {
        isLoading,
        requests,
        capabilities,
        showCapModal,
        selectedMenu,
        users,
        loading,
        toastLevel,
        toastMessage,
        showToast,
        organizationsCage,
        organizationsName,
        organizationsStatus,
        // govOrgId,
        email,
        cage,
        name,
        phone,
        orgName,
        orgCage,
        userType
      } = this.state;
      const { auth } = this.props;
      const pageProps = {
        // govOrgId,
        organizationsCage,
        organizationsName,
        organizationsStatus,
        refreshUsers: this._refreshUsers,
        loading,
        toastLevel,
        toastMessage,
        showToast,
        onSubmit: this._onSubmit,
        onGetGovernmentUsers: this._onGetGovernmentUsers,
        onChange: this._onChange,
        onViewOrgSubmit: this._onViewOrgSubmit,
        users,
        auth,
        requests,
        isLoading,
        selectedMenu,
        onMenuClick: this._onFilterClick,
        viewNewUserForm: this.state.viewNewUserForm,
        email,
        cage,
        name,
        phone,
        orgName,
        orgCage,
        refreshOrganizations: this.refreshOrganizations,
        onUpdate: this.onUpdate,
        capabilities,
        showCapModal,
        openCapModal: this.openCapModal,
        closeCapModal: this.closeCapModal,
        onHandleUserTypeSwitchChange: this._onHandleUserTypeSwitchChange,
        // userType: this.state.userType,
        userType
      };
      return <SuperAdminMenu {...pageProps} />;
    }
  }

  return withRouter(WrappedComponent);
}



// WEBPACK FOOTER //
// ./src/pages/SuperAdminHome/SuperAdminHomeHOC.jsx